import {
  Home, FileText, Activity, Pill, FolderOpen,
  Calendar, CalendarPlus, MessageSquare,
  BarChart, FlaskConical, ClipboardList,
  Bot, HelpCircle, Route, Shield, Lock
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface NavigationItem {
  id: string;
  name: string;
  path: string;
  icon: LucideIcon;
  badge?: number;
}

export interface NavigationGroup {
  id: string;
  label: string;
  icon: LucideIcon;
  items: NavigationItem[];
  isCollapsible: boolean;
  defaultExpanded: boolean;
}

export const navigationGroups: NavigationGroup[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: Home,
    isCollapsible: false,
    defaultExpanded: true,
    items: [
      { id: 'home', name: 'Home', path: '/', icon: Home },
    ],
  },
  {
    id: 'health-records',
    label: 'Health Records',
    icon: FileText,
    isCollapsible: true,
    defaultExpanded: true,
    items: [
      { id: 'medical-history', name: 'Medical History', path: '/medical-history', icon: FileText },
      { id: 'test-results', name: 'Test Results', path: '/test-results', icon: Activity },
      { id: 'medications', name: 'Medications', path: '/medications', icon: Pill },
      { id: 'medical-records', name: 'Medical Records', path: '/medical-records', icon: FolderOpen },
    ],
  },
  {
    id: 'care',
    label: 'Care',
    icon: Calendar,
    isCollapsible: true,
    defaultExpanded: true,
    items: [
      { id: 'appointments', name: 'Appointments', path: '/appointments', icon: Calendar },
      { id: 'schedule-appointment', name: 'Schedule', path: '/schedule-appointment', icon: CalendarPlus },
      { id: 'care-pathways', name: 'Care Pathways', path: '/care-pathways', icon: Route },
      { id: 'messages', name: 'Messages', path: '/messages', icon: MessageSquare },
    ],
  },
  {
    id: 'tools',
    label: 'Tools',
    icon: BarChart,
    isCollapsible: true,
    defaultExpanded: false,
    items: [
      { id: 'health-tools', name: 'Health Tools', path: '/health-tools', icon: BarChart },
      { id: 'test-catalog', name: 'Test Catalog', path: '/test-catalog', icon: FlaskConical },
      { id: 'order-test', name: 'Order Test', path: '/order-test', icon: ClipboardList },
    ],
  },
  {
    id: 'ai-support',
    label: 'AI & Support',
    icon: Bot,
    isCollapsible: true,
    defaultExpanded: true,
    items: [
      { id: 'ai-assistant', name: 'AI Assistant', path: '/ai-assistant', icon: Bot },
      { id: 'help', name: 'Help & Support', path: '/help', icon: HelpCircle },
    ],
  },
  {
    id: 'privacy',
    label: 'Privacy',
    icon: Shield,
    isCollapsible: true,
    defaultExpanded: true,
    items: [
      { id: 'consent', name: 'Consent Management', path: '/consent', icon: Shield },
      { id: 'vault', name: 'Health Vault', path: '/vault', icon: Lock },
    ],
  },
];

/** Flatten all items from groups for backward compatibility */
export const allNavigationItems: NavigationItem[] = navigationGroups.flatMap(g => g.items);
